<template>
  <main>
    <div class="container">
      <div class="row py-3 py-sm-5">
        <div class="col-12">
          <h1 class="text-white text-center">
            {{ title }}
          </h1>
        </div>
      </div>
    </div>
    <div class="container-fluid bg-white py-5">
      <div class="container blogcontainer">
        <div class="row">
          <div class="col-lg-8">
            <div class="row">
              <div
                v-for="post in posts"
                :key="post.id"
                class="col-sm-6"
              >
                <article class="card mb-3 mb-sm-4">
                  <router-link
                    class="text-white"
                    :to="{ name: 'post', params: { post: post.slug }}"
                  >
                    <div class="bg-image-box">
                      <div
                        class="bg-image-box-inner bg-image-box-inner-classic"
                        :style="{backgroundImage: 'url(' + post.image.path_thumb + ')'}"
                      />
                    </div>
                    <div class="card-body">
                      <h6 class="card-title text-dark text-truncate mb-0 pb-0">
                        {{ post.title }}
                      </h6>
                      <small class="text-dark"><em>Posted on <time>{{ post.created_at }}</time></em></small>
                    </div>
                  </router-link>
                </article>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <pagination
                  :data="pagination"
                  @pagination-change-page="setPage"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <search />
            <categories
              v-show="categories.length != 0"
              :categories="categories"
            />
            <tags
              v-show="tags.length != 0"
              :tags="tags"
            />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Posts from '../services/posts.js';

export default {
  beforeRouteEnter(to,from,next){
    let posts      = Posts.all(to.query);
    let categories = Posts.categories();
    let tags       = Posts.tags();
    Promise.all([posts,categories,tags]).then( responseArr => {
      next(vm => {
        vm.setPosts(responseArr[0]);
        vm.categories = responseArr[1].data;
        vm.tags = responseArr[2].data;
      })
    })
  },
  data () {
    return {
      posts: [],
      categories: [],
      tags: [],
      pagination: {}
    }
  },
  computed: {
    title () {

      let title = 'Blog';

      if (this.$route.query.category) {
        title = 'Blog Category: ' + this.getCategoryName(this.$route.query.category);
      }

      if (this.$route.query.tag) {
        title = 'Blog Tag: ' + this.getTagName(this.$route.query.tag);
      }

      if (this.$route.query.s) {
        title = 'Blog Search: ' + this.$route.query.s;
      }

      if (this.$route.query.page > 1) {
        title = title + ' - Page ' + this.$route.query.page;
      }

      return title;
    }
  },
  watch: {
    '$route.query.s': function (s) {
      this.fetchPosts();
    },
    '$route.query.category': function (category) {
      this.fetchPosts();
    },
    '$route.query.tag': function (s) {
      this.fetchPosts();
    },
    '$route.query.page': function (s) {
      this.fetchPosts();
    },
  },
  methods: {
    fetchPosts () {    
      Posts.all(this.$route.query).then(res => {
        this.setPosts(res);
        window.scrollTo(0,0);
      });
    },
    setPosts(res){
      this.posts = res.data;
      this.pagination = res;
    },
    fetchCategories () {    
      Posts.categories().then(res => {
        this.categories = res.data;
      });
    },
    fetchTags () {    
      Posts.tags().then(res => {
        this.tags = res.data;
      });
    },
    setPage(page = 1) {
      this.$router.push({
        query: { ...this.$route.query, page: page }
      });
    },
    getCategoryName(id) {

      let name = '';

      this.categories.forEach(function(category) {
        if (category.id == id) {
          name = category.name;
        }
        if (category.children) {
          category.children.forEach(function(child) {
            if (child.id == id) {
              name = child.name;
            }
          });
        }
      });

      return name;
    },
    getTagName(id) {
      let tag = this.tags.find(function(tag) {
        return tag.id == id;
      });

      if (tag) {
        return tag.name;
      }

      return '';
    }
  }
}
</script>
